import { MaterialDto, MaterialPercentageDto } from './material.dto';

export class MaterialPercentage {
    readonly id: string;
    readonly symbol: string;
    readonly percentage: string;

    constructor(dto: MaterialPercentageDto) {
        this.id = dto.id;
        this.symbol = dto.symbol;
        this.percentage = dto.percentage ?? '';
    }
}

export class Material {
    readonly id: string;
    readonly code: string;
    readonly name: string;
    readonly density: string;
    readonly percentages: MaterialPercentage[];

    constructor(dto: MaterialDto) {
        this.id = dto.id;
        this.code = dto.code;
        this.name = dto.name;
        this.density = dto.density;
        this.percentages = dto.percentages.map((percentage) => new MaterialPercentage(percentage));
    }
}
